import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ForgeDemo } from './samples/ui/ForgeDemo';
import './style.css';

// Tag the html root on iOS so safe-area fallback CSS in style.css can
// scope iPhone-only Dynamic Island clearance without affecting Android
// PWAs (where adding 44px of top padding would be wasteful — Android
// has no notch and reports its system status bar correctly via env()).
if (
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent)
) {
  document.documentElement.classList.add('is-ios');
}

const container = document.getElementById('root');
if (!container) throw new Error('No #root element in index.html');

// Dev-only query-string route so we can iterate on forge primitives
// without wiring them into the main shell yet. No router dep; just a
// URL check at mount time.
const forgeDemo =
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).has('forge');

createRoot(container).render(
  <StrictMode>{forgeDemo ? <ForgeDemo /> : <App />}</StrictMode>,
);
